import { NavigationService } from "@/shared/services/NavigationService";
import { SystemView } from "@/shared/constants/Views.enum";
import {
  FORM_CONSTANTS,
  FORM_VALIDATORS,
  LOCAL_STORAGE
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Vuetify from "vuetify";
import { AVAILABILITY_CONSTANTS } from "../../../Availability/constants/AvailabilityConstants";
import { AvailabilityTemplateResponse } from "../../models/AvailabilityTemplateModel";

Vue.use(Vuetify);

@Component({
  name: "ViewTemplate"
})
export default class ViewTemplate extends Vue {
  @Prop() showModal!: boolean;
  @Prop() currentAvailabilityItem!: AvailabilityTemplateResponse;

  requiredField = FORM_VALIDATORS.REQUIRED_FIELD;

  AVAILABILITY_SERVICES = AVAILABILITY_CONSTANTS.TEXTS.AVAILABILITY_SERVICES;
  VIEW_AVAILABILITY = AVAILABILITY_CONSTANTS.TEXTS.VIEW_AVAILABILITY;
  NAME_LABEL = AVAILABILITY_CONSTANTS.LABEL.NAME;
  CLOSE_BTN = FORM_CONSTANTS.BUTTON.CLOSE;
  EDIT_BTN = FORM_CONSTANTS.BUTTON.EDIT;

  btnClassPrimaryRound = STYLE_CLASSES.BASIC_ROUND_BTN;
  cardClass = STYLE_CLASSES.CARD;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;

  cancel() {
    this.$emit(AVAILABILITY_CONSTANTS.EVENTS.EDIT_MODAL_CANCEL);
  }

  viewService(serviceId: string) {
    localStorage.setItem(LOCAL_STORAGE.SERVICE_ID, serviceId);
    NavigationService.navigateTo(SystemView.SERVICES_TEMPLATE);
  }
}
